// extracted by mini-css-extract-plugin
module.exports = {"theme":"#fcf9f9"};